import { ShopifyProduct } from "../types/shopify";

const normalizeTag = (tag: string): string => tag.trim().toLowerCase();

export const hasProductTag = (product: ShopifyProduct, tagName: string): boolean =>
  product.tags?.some((tag) => normalizeTag(tag) === normalizeTag(tagName)) ?? false;

export const getHeroFeaturedProducts = (
  products: ShopifyProduct[],
  maxProducts: number
): ShopifyProduct[] => {
  if (!products.length || maxProducts <= 0) {
    return [];
  }

  const heroProducts = products.filter((product) => hasProductTag(product, "hero"));
  const featuredProducts = products.filter(
    (product) => hasProductTag(product, "featured") && !hasProductTag(product, "hero")
  );

  return [...heroProducts, ...featuredProducts].slice(0, maxProducts);
};
